
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch'; 
import axios from 'axios';

import NavBar from '../../components/navBar/NavBar';
import Footer from '../../components/footer/Footer';

import { getProductById } from '../../utils/products/products';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Card, Typography, Button, Box } from '@mui/material';
import './NewDetail.Module.css';
import product1 from "../../assets/images/CORAZON-VERDE-TRANS.png"
import product2 from "../../assets/images/CORAZON-VERDE-TRANS-FONDO.png"
import Loader from '../../components/loader/Loader';
import { agregarAlCarrito } from '../../features-slice/cart/carritoSlice';
import { currencyDisplay } from '../../utils/cart/cart';
import { Toaster, toast } from 'react-hot-toast';
import { isNewProduct } from '../../utils/products/products';
import vegan from '../../assets/Sellos/VEGAN.png';
import { isAuthenticated } from '../../utils/auth/auth';
import { useMediaQuery } from 'react-responsive';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Carousel from 'react-multi-carousel';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import christmas from "../../assets/BeautiChristmas_5.png"
import gangas from "../../assets/images/gangas3.png"
import { AddBoxTwoTone } from '@mui/icons-material';
import NavBarNew from '../../components/navBarNew/NavBarNew';



export default function NewDetail() {
    const [producto, setProducto] = React.useState({});
    const img1 = producto.img ? producto.img : product1;
    const img2 = producto.img2 ? producto.img2 : product2;
    const [loader, setLoader] = React.useState(true);
    const dispatch = useDispatch();
    const { id } = useParams();

        	const sinStock =
	(producto?.variantes?.length === 0 && (!producto.disponibles || producto.disponibles <= 0)) ||
	(producto?.variantes?.length > 0 && producto.variantes.every(v => !v.disponibles || v.disponibles <= 0));
    
    
	const searchParam = new URLSearchParams(window.location.search).get('termino');
    const [cambioImg, setCambioImg] = React.useState(false);
    const handleMouseEnter = () => {
        setCambioImg(true);
    };
    const navigate = useNavigate();
    const [showVariantSelector, setShowVariantSelector] = React.useState(false);
    const [selectedImage, setSelectedImage] = React.useState("");
    const [openDialog, setOpenDialog] = React.useState(false);
    const [selectedVarianteId, setSelectedVarianteId] = React.useState('');
    const [saleImage, setSaleImage]=React.useState("")
	React.useEffect(() => {
		const cargarVideo = async () => {
			const { data } = await axios.get(`${process.env.REACT_APP_BACK_URL}/api/imagenes?tipo=GANGA_SECTION`);
			setSaleImage(data.imagenes[0]?.url);
		};
		cargarVideo();
		window.addEventListener('actualizar-producto', cargarVideo);
	}, []);



    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };
    React.useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    React.useEffect(() => {
        toast.remove();
        const getProducto = async () => {

            const productoData=await getProductById(id)
            setProducto(productoData);
            setSelectedImage(productoData?.img)
            setLoader(false);
        };
        getProducto();
        return () => {
            setProducto({});
        };
    }, [id]);

    function manejadorAgregarACarrito() {
        if (selectedVarianteId) {
            const carritoItem = {
                ...producto,
                cantidad: 1,
                varianteId: selectedVarianteId,
            };

            dispatch(agregarAlCarrito(carritoItem));
        } else {
            dispatch(agregarAlCarrito({ ...producto, cantidad: 1 }));
        }
    }


    const urlCatalog  = `/market/categoria/64ef4986d269731b208134bf?nombre=MARKET&termino=${searchParam}`

		const isMobileScreen = useMediaQuery({ maxWidth: 768 }); // Cambio de imagen en pantallas pequeñas
		    const responsive = {
		        desktop: {
		            breakpoint: { max: 3000, min: 1024 },
		            items: 1,
		            slidesToSlide: 1,
		        },
		        tablet: {
		            breakpoint: { max: 1024, min: 464 },
		            items: 1,
		            slidesToSlide: 1,
		        },
		        mobile: {
		            breakpoint: { max: 464, min: 0 },
		            items: 1,
		            slidesToSlide: 1,
		        },
		    };
		
            const procesarCadena = (cadena) => {
                if (cadena && cadena[0].match(/\d/)) {
                    return cadena.slice(1);
                } else {
                    return cadena;
                }
            };
    const handleImageClick = () => {
        setOpenDialog(true);
    };

    return (
        <div className=''>
            <header>
                <NavBarNew/>
            </header>
            
            <div className='atrasTitle'>
						
                            </div>
                                {loader ? (
                    <Loader />
                ) : (
            <main style={{	maxWidth: !isMobileScreen && "90vw", overflowX: !isMobileScreen && "hidden"}} className='containerDetail py-4'>
            
                    <Box sx={{display:"flex",flexDirection:isMobileScreen?"column-reverse":"row", gap:"10px", cursor:"pointer", margin:"10px", justifyContent:"center", alignItems:"center"}}>
                        {
                            !isMobileScreen && (
                                <Box 
                                sx={{
                                  display: "flex",
                                  flexDirection: isMobileScreen ? "row" : "column",
                                  gap: "10px",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  margin: "10px",
                                  marginTop: "15vh"
                                }}
                              >
                                <img
                                  style={{
                                    width: isMobileScreen ? "100px" : "150px",
                                    cursor: "pointer",
                                    opacity: selectedImage === producto?.img ? 1 : 0.4,
                                    border: selectedImage === producto?.img ? "2px solid #23563F" : "none",
                                    borderRadius: "8px",
                                    transition: "all 0.3s ease"
                                }}
                                  onClick={() => setSelectedImage(producto?.img)}
                                  src={img1}
                                  alt='producto image1'
                                />
                                <img
                                  style={{
                                    width: isMobileScreen ? "100px" : "150px",
                                    cursor: "pointer",
                                    opacity: selectedImage === producto?.img2 ? 1 : 0.4,
                                    border: selectedImage === producto?.img2 ? "2px solid #23563F" : "none",
                                    borderRadius: "8px",
                                    transition: "all 0.3s ease"
                                  }}
                                  onClick={() => setSelectedImage(producto?.img2)}
                                  src={img2}
                                  alt='producto image2'
                                />
                              </Box>
                              
                            )
                        }
               
                   <>
                   <button style={{position:isMobileScreen&&"fixed", border:"none",width:"40px",marginBottom:isMobileScreen? "0vh" : "85px", top:!isMobileScreen ? "50vh":"90vh", left:isMobileScreen?"-4vw":"-8vw", backgroundColor:"#20563f!important"}} className='fondoPrevButton buttonCata' onClick={() => searchParam !== undefined && searchParam !== "undefined" && searchParam !== "" ? navigate(urlCatalog): navigate(-1)}>


                            <ChevronLeftIcon style={{ fill: "white" }} />
                        </button>
                    
                        <Card style={{ marginTop:!isMobileScreen? "15vh":"8vh", marginBottom: "65px", width: isMobileScreen ? "100vw" : "55vw", height: !isMobileScreen ? "" : "" }}>
                                <Box display="flex" flexDirection={isMobileScreen ? "column !important" : "row"}>
                                    <Toaster
                                        position='bottom-left'
                                        reverseOrder={false}
                                        toastOptions={{ className: 'fondoToast' }} />

                                    <Box style={{ position: !isMobileScreen ? "relative" : "", minWidth:"20vw", width: isMobileScreen ? "100%" : "50%", border: "none", marginBottom: "", height: "100%" }} flex={1}>

                                        <div style={{ position: "absolute", zIndex: 1 }} className=' ofertasDetail'>
                                            {producto.precioOferta > 0 && (
                                                  <img className='christmas-detail' src={saleImage} alt='SaleLogo' />
                                                // <span className='badge new-sale-detail'>#BEAUTI FRIDAY</span>
                                            )}
                                            {producto.fechaCreacion
                                                ? isNewProduct(producto.fechaCreacion) && (
                                                    <span className='badge bg-info text-white new-sale-detail'>NEW</span>
                                                )
                                                : ''}

                                            {producto.vegan && (
                                                <abbr className='veganDetail' title='Producto vegano'>
                                                    <img className='vegan' src={vegan} alt='Vegano' />
                                                </abbr>
                                            )}

                                        </div>
                                        {/* <div style={{ marginLeft: isMobileScreen ? "-25px" : "", width: "100%", display: "flex", justifyContent: "flex-end", position: "absolute", zIndex: 1 }} className="zoom-icon-container">
                                            <ZoomInIcon onClick={handleImageClick} className="zoom-icon" />
                                        </div> */}
                             

                                        <TransformWrapper>
                                            <TransformComponent >
                                            <img src={selectedImage} alt={`Imagen de`} style={{
                                                            minWidth:isMobileScreen?"100vw":"50%",
                                                            maxWidth:isMobileScreen?"100vw":"100%",
                                                                minHeight: isMobileScreen?"250px":"50vh",
                                                                 maxHeight: isMobileScreen?"400px":"",
                                                                objectFit: "cover"
                                                            }} />
                                            </TransformComponent>
                                        </TransformWrapper>
                                        {
                            isMobileScreen && (
                                <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: isMobileScreen ? "row" : "column",
                                  gap: "10px",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  margin: "10px",
                                  marginTop: "2vh"
                                }}
                              >
                                <img
                                  style={{
                                    width: isMobileScreen ? "90px" : "150px",
                                    cursor: "pointer",
                                    opacity: selectedImage === producto?.img ? 1 : 0.4,
                                    border: selectedImage === producto?.img ? "2px solid #23563F" : "none",
                                    borderRadius: "8px",
                                    transition: "all 0.3s ease"
                                  }}
                                  onClick={() => setSelectedImage(producto?.img)}
                                  src={img1}
                                  alt='producto image1'
                                />
                                <img
                                  style={{
                                    width: isMobileScreen ? "90px" : "150px",
                                    cursor: "pointer",
                                    opacity: selectedImage === producto?.img2 ? 1 : 0.4,
                                    border: selectedImage === producto?.img2 ? "2px solid #23563F" : "none",
                                    borderRadius: "8px",
                                    transition: "all 0.3s ease"
                                  }}
                                  onClick={() => setSelectedImage(producto?.img2)}
                                  src={img2}
                                  alt='producto image2'
                                />
                              </Box>
                              
                            )
                        }
               
                                        {/* <TransformWrapper>
                                            <TransformComponent  >
                                            <img src={img2} alt={`Imagen de`} 
                                                            style={{
                                                            minWidth:isMobileScreen?"100vw":"100%",
                                                                minHeight: isMobileScreen?"330px":"500px",
                                                                maxHeight: isMobileScreen?"330px":"550px",
                                                                objectFit: "cover"
                                                            }} />
                                            </TransformComponent>
                                        </TransformWrapper> */}

                                    </Box>
                                    <Box style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", border: "none",  }} flex={1} p={2}>




                                        <Box>

                                        <Typography style={{ fontSize: isMobileScreen ? "20px" : "24px", fontFamily: "Poppins",textAlign: "left", color:"#202020" }} >

                                            {procesarCadena(producto.nombre)}

                                    </Typography>
                                   
                                    <Typography style={{ fontSize: isMobileScreen ? "12px" : "14px", fontFamily: "Poppins" ,textAlign: "left"}}  >
                                        {producto.marca}
                                    </Typography>

                                    <Box style={{backgroundColor:"",display:"flex", gap:"15px", textAlign:"left"}}>

                                    <small className='text-muted'>
                                        {/* <i className='bx bxs-purchase-tag-alt'></i> */}
                                        {producto?.precioOferta > 0 ? (
                                            <>

                                                <Typography className='oferta' style={{ display:"flex", flexDirection:"column",color:"#23563F", textAlign:"left", fontWeight:600,fontSize: isMobileScreen ? "20px" : "24px" }}>
                                                                            <s style={{fontSize: isMobileScreen ? "10px" : "12px"}}>{currencyDisplay(producto.precioTarjeta)}</s> {currencyDisplay(producto.precioOferta)}
                                                                        </Typography>
                                                                        <Typography style={{ textAlign:"left",color:"#5c5c5c",fontSize: isMobileScreen ? "8px" : "10px" }}>
                                                                             con Transferencia o efectivo en el local
                                                                            </Typography>
{/* 
                                            <small style={{ fontWeight: 600, fontSize: isMobileScreen ? "14px" : "18px" }} className='text-muted oferta'>
                                                            <Typography>Producto en oferta</Typography>
                                                            <s>{currencyDisplay(producto.precioTarjeta)}</s>
                                                            {currencyDisplay(producto.precioOferta)}
                                                        </small><Typography style={{ color: "#202020", fontSize: isMobileScreen ? "10px" : "12px" }}>
                                                            con Transferencia o efectivo en el local
                                                            </Typography> */}
                                                            
                                                            </>
                                        ) : (
                                            <Box>
                                            <Typography style={{ color:"#23563F",fontWeight: 600, fontSize: isMobileScreen ? "20px" : "24px" }} >
                                                {currencyDisplay(producto.precioTarjeta)}
                                            </Typography>
                                            <Typography style={{ color:"#202020",fontSize: isMobileScreen ? "10px" : "12px" }} >
                                                <b>{currencyDisplay(producto.precioEfectivo)} </b> con Transferencia o efectivo en el local
                                            </Typography>
                                        </Box>
                                        )}
                                    </small>
                                    </Box>

                                    
                                            {
                                                 sinStock ? 
                                                                                                (
                                                  <Box
                                                      sx={{
                                                        width: "100%",
                                                        height: isMobileScreen?"38px":"45px",
                                                        backgroundColor: "#ccc",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        cursor: "not-allowed",
                                                        color: "#777",
                                                        fontFamily: "Poppins",
                                                        fontSize: isMobileScreen ? "12px" : "14px",
                                                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                                        marginTop:"10px",
                                                        margin: "auto",
                                                      }}
                                                    >
                                                      <Typography className="goBeautiGangas"
                                                            sx={{
                                                          color: "white" ,
                                                          fontFamily: "Poppins",
                                                                    fontWeight:400,
                                                                    fontSize: isMobileScreen ? "12px" : "14px",
                                                        }}
                                                            >AGOTADO</Typography>
                                                    </Box>
                                                                                                ):
                                            (
                                                <Box sx={{width:"100%",  marginTop:"15px",borderRadius:"", border:"none", display:"flex", alignItems:"center", justifyContent:"center" }}>
                                                    {producto?.variantes?.length === 0 ? (
                                                        <Box
                                                            style={{ 
                                                                borderRadius:"",
                                                                width: isMobileScreen ? "100vw" : "100%" ,
                                                                height:"38px",
                                                                 backgroundColor:"#23563F",
                                                                 display:"flex",
                                                                 justifyContent:"center",
                                                                 alignItems:"center",
                                                                 cursor:"pointer"
                                                                 }}
                                                            // className='btn btn-sm btn-outline-secondary '
                                                            onClick={manejadorAgregarACarrito}
                                                        >
                                                            <Typography sx={{color:"#ffff", fontFamily:"Poppins",fontSize:"12px"}}>Agregar a la bag</Typography>
                                                        </Box>
                                                    ) : (
                                                        <>
                                                            {!selectedVarianteId && !showVariantSelector && (
                                                                <Box
                                                                style={{ 
                                                                    borderRadius:"",
                                                                    width: isMobileScreen ? "100%" : "100%" ,
                                                                    height:"38px",
                                                                    backgroundColor:"#23563F",
                                                                    display:"flex",
                                                                    justifyContent:"center",
                                                                    alignItems:"center",
                                                                    cursor:"pointer"
                                                                    }}
                                                                 
                                                                    onClick={() => setShowVariantSelector(true)}
                                                                >
                                                                <Typography sx={{color:"#ffff", fontFamily:"Poppins", fontSize:"12px"}}>Agregar a la bag</Typography>
                                                                </Box>
                                                            )}

                                                            {showVariantSelector && producto?.variantes?.length > 0 && (
                                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "5px", width:"100%" }}>
                                                                    <select
                                                                    style={{borderRadius:"0px", height:"38px", cursor:"pointer", width:"100%", backgroundColor:"#E9CED2"}}
                                                                        value={selectedVarianteId}
                                                                        onChange={(e) => setSelectedVarianteId(e.target.value)}
                                                                    >
                                                                        <option value=''>Seleccionar variante</option>
                                                                        {producto?.variantes.filter((variante) => variante.disponibles > 0).map((variante) => (
                                                                            <option 
                                                                          
                                                                            key={variante._id} value={variante._id}>
                                                                              <Typography sx={{ fontFamily:"Poppins", fontSize:"12px"}}>  {variante.color}</Typography> 
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                    {
                                                                        showVariantSelector && producto?.variantes?.length > 0 && selectedVarianteId && (
<Box
                                                                         style={{ 
                                                                            borderRadius:"",
                                                                            width: isMobileScreen ? "100%" : "100%" ,
                                                                            height:"38px",
                                                                             backgroundColor:"#23563F",
                                                                             display:"flex",
                                                                             justifyContent:"center",
                                                                             alignItems:"center",
                                                                             cursor:"pointer"
                                                                             }}
                                                                        onClick={manejadorAgregarACarrito}
                                                                        disabled={selectedVarianteId === ''}
                                                                    >
                                                                        <Typography sx={{color:"#ffff", fontFamily:"Poppins", fontSize:"12px"}}>Agregar</Typography>
                                                                    </Box>
                                                                        )
                                                                    }
                                                                    
                                                                </div>
                                                            )}
                                                        </>
                                                    )}
                                                </Box>
                                            )}
                                        

                                        </Box>
                                        <Typography style={{ fontFamily:"Poppins", textAlign: "left", fontSize:"10px", marginTop:isMobileScreen && "15px"}} >
                                            {producto?.descripcion?.split('/n').map((paragraph, index) => (
                                                <>
                                                    <Typography key={index} style={{ fontFamily:"Poppins", textAlign: "left",fontSize:"12px" }} gutterBottom>
                                                        {paragraph.split(/(\*.*?:)/).map((text, index) => {
                                                            if (text.startsWith('*')) {
                                                                return <strong key={index}>{text}</strong>;
                                                            } else {
                                                                return text;
                                                            }
                                                        })}
                                                    </Typography>
                                                    <br></br>
                                                </>
                                            ))}
                                        </Typography>

                                      

                                            <Typography style={{ fontSize: isMobileScreen ? "8px" : "10px", fontFamily: "Montserrat", fontWeight:600 }} variant="h6" gutterBottom>

                                            *Accede a los precios promo abonando contado efectivo en el local.

                                            </Typography>
                                      


                                    </Box>
                                </Box>

                            </Card>
                            </>
                            </Box>
            <Dialog open={openDialog} onClose={handleCloseDialog}>
  <DialogContent sx={{ maxWidth: 'none', width: '1200px' }}>
    <img src={cambioImg ? img2 : img1} alt={`Imagen de ${producto?.nombre}`} style={{ width: '100%' }} />
  </DialogContent>
</Dialog>

            </main>
                )}
            {/* <GloboContacto /> */}
            <footer>
                <Footer />
            </footer>
        </div>
    );
}
